export const SESSION_ID_QUERY_PARAM_NAME = "session_id";